import { gql, graphql } from "react-apollo"
import type { CreatePreSignedS3URLMutation } from "../types"

const MUTATE_CREATE_ASSET_UPLOAD_URL = gql`
  mutation CreateAssetUploadURL($filename: String!, $mimeType: String!) {
    createAssetUploadURL(filename: $filename, mimeType: $mimeType) {
      expiresAt
      signedURL
      fileKey
      filename
    }
  }
`

const mutateCreateAssetUploadURL = graphql(MUTATE_CREATE_ASSET_UPLOAD_URL, {
  name: "mutateCreateAssetUploadURL",
  props: ({
    mutateCreateAssetUploadURL
  }): { createAssetUploadURL: CreatePreSignedS3URLMutation } => ({
    createAssetUploadURL: (filename, mimeType) =>
      mutateCreateAssetUploadURL({ variables: { filename, mimeType } })
  })
})

export default mutateCreateAssetUploadURL



// WEBPACK FOOTER //
// ./src/S3/queries/mutateCreateSignedUploadURL.js